import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from '../event/event.service';

import { Navigator } from './navigator';
import { ROUTE_PATHS } from 'src/library/app-routes.lib';

@Injectable({
  providedIn: 'root'
})

export class RoutingService {

  private navigator: any;

  constructor(
    private events: EventsService,
    private injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  public defaultRoute(useDismissAll: boolean = true): void {
    if (useDismissAll) setTimeout(() => this.getNavigator().dismissAll(), 50);
    this.toLobbyTab();
  }

  public toGameTab(): void {
    this.toRoute(ROUTE_PATHS.GAME);
  }

  public toLobbyTab(categoryName?: string): void {
    this.toRoute(ROUTE_PATHS.LOBBY, categoryName)
  }

  public toLiveDealerTab(dismissModals: boolean = false): void {
    if (dismissModals) {
      this.getNavigator().dismissAll();
    }
    this.toRoute(ROUTE_PATHS.LIVE_DEALER);
  }

  public toPromotionsTab(): void {
    this.toRoute(ROUTE_PATHS.PROMOTIONS);
  }

  public toPageSelectorTab(dismissModals: boolean = false): void {
    if (dismissModals) {
      this.getNavigator().dismissAll();
    }
    this.toRoute(ROUTE_PATHS.PAGE_SELECTOR);
  }

  public toWebviewTab(dismissModals: boolean = false, link?: string): void {
    this.toRoute(ROUTE_PATHS.ARTICLE, link);
  }

  public toRoute(name: string, extPath?: any): void {
    this.getNavigator().setCurrentActiveLobby(name);
    this.getNavigator().setCurrentActiveRouteExtPath(extPath);
    const finalRoutePath = extPath ? [name, extPath] : [name];
    this.router.navigate(finalRoutePath).then(() => this.sendHistoryEvent(finalRoutePath.join('/')));
  }

  public sendHistoryEvent(path: string): void {
    this.events.publish("event:history:push", { page: path });
  }

  private getNavigator(): Navigator {
    if (!this.navigator) {
      this.navigator = this.injector.get(Navigator);
    }
    return this.navigator;
  }

  public toLobbyTabWithReplaceUrl() {
    return this.router.navigate([ROUTE_PATHS.LOBBY], {
      replaceUrl: true  // This won't add page-selector to the history stack
    });
  }

  public toModalRoute(pageName) {
    let componenetName = pageName?.substr(0, pageName.length - 9)
    let componenetRouteName = componenetName?.toLowerCase();
    this.router.navigate([`/${componenetRouteName}`], { relativeTo: this.route });
  }

}
